import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class WhyChooseHome extends React.Component{

    constructor(){
        super();

        
        this.state = { 
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
        if(JSON.parse(localStorage.getItem("settings")))
        {
            this.setState({settings:JSON.parse(localStorage.getItem("settings"))}) ;
            this.setState({loading:0})
        }
        else{
            axios.get(api_base_url+"settings").then(response=>{
                this.setState({settings:response.data}) ;
            });
        }
        if(JSON.parse(localStorage.getItem("page_content")))
        {
            this.setState({page_content:JSON.parse(localStorage.getItem("page_content"))}) ;
        }
        else
        {
            axios.get(api_base_url+"page_content").then(response=>{
                this.setState({page_content:response.data}); 
                this.setState({loading:0})
            }); 
        }
        
    }


    render()
    { 
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
        
          <div class="stat-summary">
        <div class="stat-content">
         <div class="stat-block" data-aos="fade-up">
          <h1>
           STATISTICS
          </h1>
          <p>
           With thousands of rigs and vessels inspected, over a thousand
        helidecks surveyed, and hundreds of asset integrity surveys performed,
        ESTA has built a reputation for being a reliable partner in the energy
        sector.
          </p>
          <Link class="readmore1" to={base_url+`key-figures`}>
           EXPLORE OUR STATS
          </Link>
         </div>
         <div class="stat sidebar" data-aos="fade-up" data-aos-delay="250">
          <div class="stat-number">
           +117
           <number from="0" refs="n1" to="117">
           </number>
          </div>
          <div class="stat-desc">
           PROJECTS
           <br/>
           AND MORE
          </div>
         </div>
         <div class="stat sidebar" data-aos="fade-up" data-aos-delay="500">
          <div class="stat-number">
           +173
           <number from="0" refs="n2" to="173">
           </number>
          </div>
          <div class="stat-desc">
           ENVIROMENTAL SOLUTION
          </div>
         </div>
         <div class="stat" data-aos="fade-up" data-aos-delay="750">
          <div class="stat-number">
           +615
           <number from="0" refs="n2" to="615">
           </number>
          </div>
          <div class="stat-desc">
           ASSET INTEGRITY SURVEYS
          </div>
         </div>
        </div>
       </div>
       
 
    );
}

}

export default WhyChooseHome;